export class QuestionClass {
    "id" ?: number;
    "question": string;
    "a": string;
    "b": string;
    "c": string;
    "d": string;
    "answer": string;
    "selected" ?: string;
    "review" ?:string;
}





// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/questions/question-class.ts